import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form-mui';
import { CreateFragmentFormValues } from './useFragmentForm';

type Props = {
  onChangedValues?: (values: CreateFragmentFormValues) => void;
};

/**
 * Side effects for the create-fragment form: notify parent when dirty values change.
 */
export function CreateFragmentFormEffects({ onChangedValues }: Props) {
  const { control, formState } = useFormContext<CreateFragmentFormValues>();
  const watchedValues = useWatch({ control });
  const isDirty = formState.isDirty;

  useEffect(() => {
    if (isDirty && watchedValues && onChangedValues) {
      onChangedValues(watchedValues as CreateFragmentFormValues);
    }
  }, [isDirty, watchedValues, onChangedValues]);

  return null;
}
